<template>
    <template v-for="(item,key) in  sections" :key="key">
        <tr>
            <td class="text-center" >{{ item.label }}</td>
            <td class="fw-bold text-capitalize" :class="{'ps-3' : item.level==2,'ps-4' : item.level==3}">{{ item.name }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td v-if="item.expectedAmount" class="text-end">{{ ReformatNumber(item.expectedAmount) }}</td>
            <td v-else></td>
        </tr>
        <BoqCreatorPrintViewRow :sections="item.childs" :IsOpenBook="IsOpenBook" :boqId="boqId" :imageSummaries="imageSummaries" :imageContextType="imageContextType" @open-images="$emit('open-images', $event)" />
        <tr v-for="(lineItem,lineKey) in item.lineItems" :key="lineKey">
            <td class="text-center">{{ lineKey + 1 }}</td>
            <td class="bg-white">
                <div >
                    <div :class="{'ps-4' : item.level==2,'ps-5' : item.level==3}" >
                        <small class="fw-bold text-capitalize" v-if="userInfo.language=='en'">{{lineItem.name}}</small> 
                        <small class="fw-bold text-capitalize" v-else>{{lineItem.nameCh}}</small> 
                        <br />
                        <p class="small mb-0 description-line-item">
                            {{lineItem.description}}
                        </p>
                    </div>
                </div>
            </td>
            <td class="boq-print-image-cell">
                <template v-if="imageSummaries?.[lineItem._id]?.image">
                    <span class="boq-print-image-button" role="button" tabindex="0" :aria-label="$t('View image') + ': ' + lineItem.name" @click="$emit('open-images', lineItem)" @keydown.enter="$emit('open-images', lineItem)" @keydown.space.prevent="$emit('open-images', lineItem)">
                        <BoqItemImage class="boq-print-image" :boqId="boqId" :itemId="lineItem._id" :image="imageSummaries[lineItem._id].image" :imageContextType="imageContextType || 'boq'" :alt="imageSummaries[lineItem._id].image.originalFilename || lineItem.name" />
                        <small v-if="imageSummaries[lineItem._id].count > 1" class="boq-print-image-count">{{ imageSummaries[lineItem._id].count }} {{ $t('images') }}</small>
                    </span>
                </template>
                <span v-else class="boq-print-image-empty" :aria-label="$t('No image')">
                    <i class="fa-regular fa-image" aria-hidden="true"></i>
                    <small>{{ $t('No image') }}</small>
                </span>
            </td>
            <td>{{lineItem.area}}</td>
            <td>{{lineItem.unit}}</td>
            <td class="text-end">
                {{ lineItem.rateOnly ? '-' : ReformatNumber(lineItem.totalQuantity) }}
            </td>
            <td class="text-end">
                
                <span v-if="IsIncludedLine(lineItem)">{{ ReformatNumber(IsOpenBook ?  lineItem.costRateTotal : lineItem.sellRate) }}</span>
                <span v-else>-</span>
            </td>
            <td class="text-end" >
                <span class="text-danger" v-if="lineItem.rateOnly">{{ $t('RATE ONLY') }}</span>
                <span class="text-info ms-1" v-else-if="HasNonIncludedRemark(lineItem)">{{ $t('BillOfQuantityRemark.' + lineItem.remark) }}</span>
                <span v-else>
                    {{ ReformatNumber(IsOpenBook ?  lineItem.costTotal : lineItem.sellTotal)}}
                </span>
            </td>
        </tr>
        <tr class="fw-bold" v-if="item.lineItems?.length!=0  && (item.subTotal?.sellTotal && item.subTotal?.sellTotal!=0) && IsOpenBook">
            <td ></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="text-end">{{ $t('Uplift of') }} {{ item.name }}</td>
            <td class="text-end">{{ ReformatNumber(item.subTotal?.sellTotal - item.subTotal?.costTotal) }}</td>
        </tr>
        <tr class="fw-bold" v-if="item.lineItems?.length!=0  && (item.subTotal?.sellTotal && item.subTotal?.sellTotal!=0)">
            <td ></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="text-end">{{$t('Sub Total Of')}} {{ item.name }} </td>
            <td class="text-end">{{ ReformatNumber(item.subTotal?.sellTotal) }}</td>
        </tr>
    </template>
</template>



<script>
import {ReformatNumber} from '@/helpers/utilities.js'
import BoqCreatorPrintViewRow from '../boq/BoqCreatorPrintViewRow.vue'
import BoqItemImage from '../boq/BoqItemImage.vue'
import { mapGetters } from 'vuex';
export default{
    name :'BoqCreatorPrintViewRow',
    emits : ['open-images'],
    components : {BoqCreatorPrintViewRow,BoqItemImage},
    methods : {
        ReformatNumber,
        IsIncludedLine(lineItem) {
            return !lineItem.remark || lineItem.remark === 'Included'
        },
        HasNonIncludedRemark(lineItem) {
            return !!lineItem.remark && lineItem.remark !== 'Included'
        }
    },
    props : ['IsOpenBook','sections','boqId','imageSummaries','imageContextType'],
    computed : {
        ...mapGetters(['userInfo'])
    }
}
</script>

<style scoped>
.boq-print-image-button {
    display: block;
    width: 100%;
    border: 0;
    padding: 0;
    background: transparent;
    color: inherit;
    cursor: pointer;
}

.boq-print-image-button:focus-visible {
    outline: 2px solid #ca5015;
    outline-offset: 2px;
}

.boq-print-image-empty {
    display: inline-flex;
    width: 6rem;
    height: 4.5rem;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 0.35rem;
    border: 1px solid #d5deea;
    border-radius: 0;
    background: #f8fafc;
    color: #526987;
}

.boq-print-image-empty small {
    font-size: 0.68rem;
}

@media print {
    .boq-print-image-button {
        cursor: default;
    }
}
</style>
